import { GistBox } from '../../components/GistBox';
import type { EmbedADT, EmbedProps } from '../../type';

export function githubGist(input: EmbedADT) {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;
  if (host !== 'gist.github.com') return input;

  const children = <GistBox source={input.href} />;
  return (props: EmbedProps) => {
    return (
      <div className={'w-full'} data-first={props['data-first']} data-last={props['data-last']}>
        {children}
      </div>
    );
  };
}
